// extracted by mini-css-extract-plugin
module.exports = {"root":"viz_root__2pF8w","canvas":"viz_canvas__24uS4"};